"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "settimo-milanese": {
    "62edf232": [{
      "hkey": "84da3beb",
      "slug": "seguro",
      "name": "Seguro",
      "primary": true,
      "skipSearch": false
    }],
    "seguro-villaggio-cavour": [{
      "hkey": "84da3beb",
      "slug": "seguro",
      "name": "Seguro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;